import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { StatusPill } from './StatusPill';

// One per-repo override, as a DERIVED FACT — not a control (slice 06).
//
// Both flags the settings projection returns are computed server-side from the
// repo's own `.maintainer.yml` (`override_global_rules` = the repo has its own
// policy snapshot, `strict_linting` = `pr.required_checks` is non-empty). The
// file in the repo is the source of truth — the dashboard never writes it — so
// this renders state plus WHERE it comes from, instead of a switch that could
// only ever be disabled.

export function OverrideRow(props: {
  readonly label: string;
  readonly on: boolean;
  /** Which `.maintainer.yml` field the flag is derived from. */
  readonly source: string;
}): JSX.Element {
  return (
    <li class="override-row">
      <div class="override-row__lines">
        <p class="override-row__label">{props.label}</p>
        <p class="override-row__source">
          <code>{props.source}</code>
        </p>
      </div>
      <StatusPill tone={props.on ? 'success' : 'neutral'}>
        {t(props.on ? 'repo_detail.settings_on' : 'repo_detail.settings_off')}
      </StatusPill>
    </li>
  );
}
